import { rankingComics, latestUpdates } from '@/mocks/homeData';
import { Link } from 'react-router-dom';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-8">
          <div className="lg:col-span-3">
            <div className="mb-8">
              <span className="text-accent-500 text-xs font-medium tracking-wider uppercase">
                热门榜单
              </span>
              <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mt-2">
                韩漫排行榜
              </h2>
              <p className="text-foreground-500 text-sm mt-2">
                根据阅读量、评分和热度综合排序
              </p>
            </div>

            <div className="bg-background-50 rounded-2xl overflow-hidden">
              {rankingComics.map((comic, index) => (
                <Link
                  key={comic.rank}
                  to="/"
                  className={`flex items-center gap-4 px-5 py-4 hover:bg-background-100 transition-colors cursor-pointer ${
                    index < rankingComics.length - 1 ? 'border-b border-background-200/70' : ''
                  }`}
                >
                  <span
                    className={`w-8 h-8 flex items-center justify-center rounded-full text-sm font-bold flex-shrink-0 ${
                      comic.rank <= 3
                        ? 'bg-accent-500 text-background-50'
                        : 'bg-background-200 text-foreground-600'
                    }`}
                  >
                    {comic.rank}
                  </span>
                  <div className="flex-1 min-w-0">
                    <h3 className="font-medium text-foreground-950 text-sm truncate">{comic.title}</h3>
                    <div className="flex items-center gap-3 text-xs text-foreground-500 mt-0.5">
                      <span>{comic.category}</span>
                      <span className="flex items-center gap-0.5">
                        <i className="ri-star-fill text-accent-500 text-[10px]"></i>
                        {comic.rating}
                      </span>
                    </div>
                  </div>
                  <div className="flex items-center gap-2 flex-shrink-0">
                    <span className="text-xs text-foreground-400">{comic.views}</span>
                    {comic.trend === 'up' && (
                      <i className="ri-arrow-up-line text-green-500 text-sm"></i>
                    )}
                    {comic.trend === 'down' && (
                      <i className="ri-arrow-down-line text-red-400 text-sm"></i>
                    )}
                    {comic.trend === 'new' && (
                      <span className="text-[10px] text-accent-500 font-medium">NEW</span>
                    )}
                  </div>
                </Link>
              ))}
            </div>
          </div>

          <div className="lg:col-span-2">
            <div className="mb-8">
              <span className="text-secondary-600 text-xs font-medium tracking-wider uppercase">
                实时更新
              </span>
              <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mt-2">
                最新更新
              </h2>
              <p className="text-foreground-500 text-sm mt-2">
                第一时间获取最新漫画章节
              </p>
            </div>

            <div className="bg-background-50 rounded-2xl p-5">
              {latestUpdates.map((update, index) => (
                <Link
                  key={update.id}
                  to="/"
                  className={`flex items-center justify-between py-3 hover:text-accent-500 transition-colors cursor-pointer ${
                    index < latestUpdates.length - 1 ? 'border-b border-background-200/70' : ''
                  }`}
                >
                  <div className="min-w-0 flex-1">
                    <h3 className="text-sm font-medium text-foreground-950 truncate">{update.title}</h3>
                    <span className="text-xs text-foreground-500">{update.chapter}</span>
                  </div>
                  <span className="text-xs text-foreground-400 flex-shrink-0 ml-3">{update.updatedAt}</span>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}